export const MENU_ITEM_CATEGORY_KEY = 'base' as const;
export const MENU_ITEM_COMPONENT_KEY = 'menuItem' as const;
